import { createFileRoute } from '@tanstack/react-router'
import { pageTitle, translateApp } from '@/lib/i18n'
import { ProfileLayout } from '@/routes/(private)/profile/-components/profile-layout'

export const Route = createFileRoute('/(private)/profile')({
	staticData: {
		breadcrumb: 'profile:title'
	},
	component: ProfileLayout,
	head: () => ({
		meta: [{ title: pageTitle(translateApp('it', 'profile:title')) }]
	})
})
